module.exports = __webpack_public_path__ + "img/YugaLabs.0eb3fb8e.png";